import { createContext } from 'react';
import { IUserContext } from "./useFindUser";

//set initial value of user to null (pre-login)
const UserContext = createContext<IUserContext>(null);
export default UserContext
